import {Component, Input, OnInit}       from '@angular/core';
import {ModalController, NavController} from '@ionic/angular';
import {APIService, GetUserQuery}       from 'src/app/API.service';
import {Router}                         from '@angular/router';
import {EditUserPage}                   from '../../../edit-user/edit-user.page';
import {SessionService}                 from '../../../services/session.service';
import {DataStore, SortDirection}       from '@aws-amplify/datastore';
import {Contract, PermissionType, User} from '../../../../models';
import {Predicates}                     from 'aws-amplify';
import {forEach}                        from "@angular-devkit/schematics";

@Component({
    selector: 'app-clients-list',
    templateUrl: './clients.component.html',
    styleUrls: ['./clients.component.scss'],
})
export class ClientsComponent implements OnInit {
    @Input() owner: GetUserQuery;
    @Input() showCommerciale = false;
    sortDirection = SortDirection.ASCENDING;
    userList = [];
    filteredUserList: any;
    cssClass: string;
    contractNumbers =[]

    constructor(
            public navController: NavController,
            public apiService: APIService,
            public sessionService: SessionService,
            public router: Router,
            public modalController: ModalController,
    ) {
    }

    async ngOnInit() {
        await this.refreshUserList();
    }

    private async refreshUserList() {
        this.userList = [];
        // if (this.owner.permessions)
        let filter = u => {
            return u.permessions == PermissionType.CLIENT && u.addedBy == this.owner.id;
        };
        let users = [];
        if (this.owner == this.sessionService.getCurrentUser() && this.owner.permessions == PermissionType.ADMINISTRATOR && !this.showCommerciale) {
            users = this.filteredUserList = (await DataStore.query(User, Predicates.ALL, {
                sort: s => s.lastname(this.sortDirection).name(this.sortDirection),
            }));

        } else {
            users = this.filteredUserList = (await DataStore.query(User, Predicates.ALL, {
                sort: s => s.lastname(this.sortDirection).name(this.sortDirection),
            })).filter(filter);

        }


        for (const u of users) {
            const usr = {...u};
            const contracts = await DataStore.query(Contract);
            usr['numContracts'] = contracts.filter(c => {
                return c.clientId == u.id;
            }).length;
            if ((u.addedBy == this.owner.id || this.owner.permessions == PermissionType.ADMINISTRATOR) && u.email != this.owner.email && u.permessions == PermissionType.CLIENT)
                this.userList.push(usr);
        }
        this.filteredUserList = this.userList;
        
        // this.applyClassBySelection('rollIn');
    }

    openUserProfile(userId) {
        this.cssClass = '';
        this.router.navigate(['/profile', userId]);
    }

    async addUser() {
        const modal = await this.modalController.create({
            component: EditUserPage,
            componentProps: {userId: null, isClient: false},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            this.refreshUserList();
        });
    }

    async edit(userId: string) {
        const modal = await this.modalController.create({
            component: EditUserPage,
            componentProps: {userId: userId},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            this.refreshUserList();
        });
    }

    async delete(userId: string) {
        if (confirm('Do you really want to delete this user?')) {
            await DataStore.delete(User, userId);
            // let the animation finish its job
            setTimeout(() => {
                this.refreshUserList();
            }, 1000);
        }
    }

    applyClassBySelection(effect: string): void {
        this.cssClass = 'animated ' + effect;
    }

    filterUsers(filters) {
        

        if (filters['name'].trim().length == 0) {
            
            this.filteredUserList = this.userList;
            return;
        }

        
        this.filteredUserList = this.userList.filter(u => {
            let matcheNames = '.+';

            if (filters['name'].trim().length != 0) matcheNames = filters['name'];
            const reName = new RegExp(matcheNames, 'gi');

            // make sure we don't take into account users with no name
            if (!u.name && !u.lastname) return false;

            return `${u.name} ${u.lastname}`.match(reName);
        });
    }
    trackItems(index: number, itemObject: any) {
        return itemObject.id;
    }
    async getContractsNumber(id) {
        return (await DataStore.query(Contract, condition => condition.clientId('eq', id))).length

    }
}
